/**
 * Register a handler when the user clicks any button to disconnect from their account.
 *
 * @param {VoidFunction} func
 */
export function onDisconnect(func) {
  const handler = () => func();

  // The cockpit renders its identity menu, and so its disconnect button, twice: in the header and
  // in the bottom bar.
  const disconnectEls = document.querySelectorAll(".js-app-nav-disconnect, .js-app-nav-disconnect-mobile");
  for (const disconnectEl of disconnectEls) {
    disconnectEl.addEventListener("click", handler);
  }
}

/**
 * Register a handler when the user changes the current academy they are logged on.
 *
 * @param {VoidFunction} func
 */
export function onChangeAcademy(func) {
  const handler = () => func();

  const elements = document.querySelectorAll(".js-change-academy");
  for (const el of elements) {
    el.addEventListener("click", handler);
  }
}
